import { useTranslation } from 'react-i18next';

type CountryOption = {
    value: string;
    title: string;
    index: number;
};

export const useCountriesArr = (): CountryOption[] => {
    const { i18n } = useTranslation();

    const countries: Record<string, string> =
        i18n.getResourceBundle(i18n.language, 'translation')?.common.countries || {};

    return Object.entries(countries).map(([value, title], index) => ({
        value,
        title,
        index,
    }));
};
